module.exports = __webpack_public_path__ + "static/img/1.4c3c0d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/zh/1.png
// module id = z45/
// module chunks = 0